import { getUserFullName } from 'src/helpers';
import { USERS } from 'src/constants';
import { User, UserDropDownOption } from 'src/types';

// The user database is hardcoded for now; this service and IoC are set up to accommodate potential future changes

export class UserService {
  private static readonly USER_DB: User[] = USERS;
  private static readonly DEFAULT_USER = UserService.USER_DB[0];

  async getUserById(userId: string) {
    const user = UserService.USER_DB.find((user) => user.userId === userId);

    return user as User;
  }

  async getUserDropDownOptions(): Promise<UserDropDownOption[]> {
    return UserService.USER_DB.map((user) => ({
      userId: user.userId,
      userFullName: getUserFullName(user),
    }));
  }

  async getDefaultUser(): Promise<User> {
    return UserService.DEFAULT_USER;
  }
}

export default UserService;
